<template>
  <div id="wp-west-suggest-main">
    
    <searchBar/>
     
             
  </div>
</template>

<script>
import searchBar from './components/searchBar'



export default {
  name: 'wp-west-suggest',
  components: {
    searchBar   
  }
}
</script>

<style>
#wp-west-suggest-main {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
  width:100%;
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue